// extracted by mini-css-extract-plugin
export default {"wrapper":"GlobalEmptyPage_wrapper__6vo-1","imageWrapper":"GlobalEmptyPage_imageWrapper__SaBds","iconWrapper":"GlobalEmptyPage_iconWrapper__NBsEE"};